// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see SingleUsePaymentCancelViewConfirmSheetEvent
 */
export var SingleUsePaymentCancelViewConfirmSheet = function (_a) {
    var paymentToken = _a.paymentToken;
    return ({
        name: "SingleUsePayment Cancel ViewConfirmSheet",
        parameters: {
            cdf_entity: "SingleUsePayment",
            cdf_action: "Cancel",
            payment_token: paymentToken !== undefined && paymentToken !== null ? paymentToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SingleUsePaymentCancelTapConfirmButtonEvent
 */
export var SingleUsePaymentCancelTapConfirmButton = function (_a) {
    var paymentToken = _a.paymentToken;
    return ({
        name: "SingleUsePayment Cancel TapConfirmButton",
        parameters: {
            cdf_entity: "SingleUsePayment",
            cdf_action: "Cancel",
            payment_token: paymentToken !== undefined && paymentToken !== null ? paymentToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SingleUsePaymentCancelDismissConfirmSheetEvent
 */
export var SingleUsePaymentCancelDismissConfirmSheet = function (_a) {
    var paymentToken = _a.paymentToken;
    return ({
        name: "SingleUsePayment Cancel DismissConfirmSheet",
        parameters: {
            cdf_entity: "SingleUsePayment",
            cdf_action: "Cancel",
            payment_token: paymentToken !== undefined && paymentToken !== null ? paymentToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
